import * as React from 'react';

const CrossIcon = (props) => (
    <svg
        preserveAspectRatio="xMidYMid"
        style={{
            margin: 'auto',
            background: '0 0',
            display: 'block',
            shapeRendering: 'auto'
        }}
        width={24}
        height={24}
        fill="none"
        {...props}
    >
        <path stroke={props.stroke || '#8B8AA8'} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 6 6 18M6 6l12 12" />
    </svg>
);
export default CrossIcon;
